var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2656 56H11.7344C9.16785 56 7.0871 53.9194 7.0871 51.3527V4.64734C7.08721 2.08064 9.16785 0 11.7344 0H33.0629C34.2509 0 35.3938 0.455 36.2568 1.27137L47.4594 11.8697C48.3872 12.7474 48.9129 13.9684 48.9129 15.2457V51.3527C48.9129 53.9194 46.8322 56 44.2656 56Z",
    fill: "#FDC94C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4593 11.8697L36.2567 1.27137C35.3937 0.454891 34.2509 0 33.0629 0H28V56H44.2656C46.8322 56 48.9129 53.9194 48.9129 51.3527V15.2457C48.9128 13.9684 48.3872 12.7475 47.4593 11.8697Z",
    fill: "#ECAF2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5977 13.9422H48.7249C48.4959 13.1589 48.0637 12.4415 47.4596 11.8699L36.2568 1.27161C35.6936 0.738625 35.0105 0.360953 34.274 0.162109V11.6185C34.274 12.9018 35.3144 13.9422 36.5977 13.9422Z",
    fill: "#FDC94C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6062 25.1562H14.3938C13.4514 25.1562 12.6875 24.4217 12.6875 23.5156C12.6875 22.6096 13.4514 21.875 14.3938 21.875H41.6062C42.5486 21.875 43.3125 22.6096 43.3125 23.5156C43.3125 24.4217 42.5486 25.1562 41.6062 25.1562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6062 33.9062H14.3938C13.4514 33.9062 12.6875 33.1717 12.6875 32.2656C12.6875 31.3596 13.4514 30.625 14.3938 30.625H41.6062C42.5486 30.625 43.3125 31.3596 43.3125 32.2656C43.3125 33.1717 42.5486 33.9062 41.6062 33.9062Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7594 42.6562H14.3938C13.4514 42.6562 12.6875 41.9217 12.6875 41.0156C12.6875 40.1096 13.4514 39.375 14.3938 39.375H23.7594C24.7018 39.375 25.4657 40.1096 25.4657 41.0156C25.4657 41.9217 24.7017 42.6562 23.7594 42.6562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3125 23.5156C43.3125 22.6096 42.5486 21.875 41.6062 21.875H28V25.1562H41.6062C42.5486 25.1562 43.3125 24.4217 43.3125 23.5156Z",
    fill: "#EBCDB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6062 30.625H28V33.9062H41.6062C42.5486 33.9062 43.3125 33.1717 43.3125 32.2656C43.3125 31.3596 42.5486 30.625 41.6062 30.625Z",
    fill: "#EBCDB9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentUpload);
export default __webpack_public_path__ + "static/media/document-upload.6149c1f7.svg";
export { ForwardRef as ReactComponent };